/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Trip_Resolve_Cash_Ledger_NoteInputs */

const vi_trip_resolve_cash_ledger_note = /** @type {(inputs: Trip_Resolve_Cash_Ledger_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiền mặt sẽ ghi vào sổ tài xế ${i?.name} — tài xế nộp lại khi đối soát`)
};

/**

* @param {Trip_Resolve_Cash_Ledger_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_resolve_cash_ledger_note = /** @type {((inputs: Trip_Resolve_Cash_Ledger_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Resolve_Cash_Ledger_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_resolve_cash_ledger_note(inputs)
});